import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";

export const fetchUserSurveyAnswers = (
  userId: number,
  setSurveyAnswers: Function,
  langauge: string,
  setLoading: Function
) => {
  setLoading(true);
  ApiService.get(`users/${userId}/surveys/answers`)
    .then((response) => setSurveyAnswers(response.data.user_survey_answers))
    .catch((error) => {
      console.error("Error while fetching user survey answers", error);
      alert(translate(langauge, "PAGES.USER.SURVEY.ALERTS.ERROR.FETCHING_SURVEYS_ANSWERS"));
    })
    .finally(() => setLoading(false));
};
